module.exports = __webpack_public_path__ + "img/imagemdigital.bcff7641.png";